import { NgModule } from '@angular/core'

import { FlxIconModule, provideExtraIconSet } from '@flowx/angular-ui-toolkit'

import {
  ICON_ARROW_CIRC_DOWN_LEFT,
  ICON_ARROW_DOWN,
  ICON_ARROW_LEFT,
  ICON_ARROW_SEMI_CIRC_UP_RIGHT,
  ICON_ARROW_UP,
  ICON_CIRCLE_MINUS,
  ICON_COMMAND_MACOS,
  ICON_COPY_PROMPT,
  ICON_FLOWX_WHITE,
  ICON_GENERATE_BPMN_PROCESS,
  ICON_GENERATE_BUSINESS_RULE,
  ICON_GENERATE_DESIGNER_UI,
  ICON_GRAPH_CONNECTED,
  ICON_GRIP_LINES,
  ICON_MAGNIFYING_GLASS,
  ICON_PAPERCLIP,
  ICON_STARS_FLOWX_BLACK,
  ICON_STARS_FLOWX_BLUE,
  ICON_STARS_FLOWX_WHITE,
  ICON_STARS_FLOWX_YELLOW,
  ICON_THUMBS_DOWN,
  ICON_THUMBS_UP,
} from './ai-icons.dictionary'

import { ShortcutIconName } from '../ai.dictionary'

export const AiShortcutIcons = {
  [ShortcutIconName.ArrowUp]: ICON_ARROW_UP,
  [ShortcutIconName.ArrowDown]: ICON_ARROW_DOWN,
  [ShortcutIconName.ArrowCircDownLeft]: ICON_ARROW_CIRC_DOWN_LEFT,
  [ShortcutIconName.CommandMacOS]: ICON_COMMAND_MACOS,
}

export const AiIcons = {
  'stars-flowx-white': ICON_STARS_FLOWX_WHITE,
  'stars-flowx-yellow': ICON_STARS_FLOWX_YELLOW,
  'stars-flowx-blue': ICON_STARS_FLOWX_BLUE,
  'stars-flowx-black': ICON_STARS_FLOWX_BLACK,
  'grip-lines': ICON_GRIP_LINES,
  'circle-minus': ICON_CIRCLE_MINUS,
  'paperclip': ICON_PAPERCLIP,
  'arrow-left': ICON_ARROW_LEFT,
  'graph-connected': ICON_GRAPH_CONNECTED,
  'magnifying-glass': ICON_MAGNIFYING_GLASS,
  'arrow-semi-circ-up-right': ICON_ARROW_SEMI_CIRC_UP_RIGHT,
  'action-analyst': ICON_GENERATE_BPMN_PROCESS,
  'action-developer': ICON_GENERATE_BUSINESS_RULE,
  'action-designer': ICON_GENERATE_DESIGNER_UI,
  'copy-prompt': ICON_COPY_PROMPT,
  'thumbs-up': ICON_THUMBS_UP,
  'thumbs-down': ICON_THUMBS_DOWN,
  'flowx-logo-white': ICON_FLOWX_WHITE,
  ...AiShortcutIcons,
}
@NgModule({
  imports: [FlxIconModule],
  providers: [provideExtraIconSet(AiIcons)],
  exports: [FlxIconModule],
})
export class AiIconsModule {}
